<script setup lang="ts">
import { EmbedSizeOption, embedSizeOptions } from '@@/bits/slideshow'
import SurfaceRowDropdown from '@@/vuecomponents/SurfaceRowDropdown.vue'
import { __ } from '@@/bits/intl'
import { OzMenuRowsRow, OzMenuRowsRowStyle } from '@@/library/v4/components/OzMenuRows.vue'
import { computed } from 'vue'

const props = defineProps<{
  embedSize: EmbedSizeOption
  darkMode: boolean
}>()

const rows = computed(() =>
  embedSizeOptions.map((option) => {
    return {
      htmlText: `<p class='text-body-small ${props.darkMode ? 'text-light-text-100' : 'text-dark-text-100'}'>${
        option.title
      }</p><p class='text-body-extra-small ${props.darkMode ? 'text-light-text-200' : 'text-dark-text-200'}'>${
        option.width
      } x ${option.height}</p>`,
      rightIcon: option.key === props.embedSize.key ? 'radio_selected' : 'radio_unselected',
      rightIconSize: 24,
      rightIconHighlighted: option.key === props.embedSize.key,
      rowStyle: OzMenuRowsRowStyle.Secondary,
      ariaChecked: String(option.key === props.embedSize.key),
      eventPayload: option,
    } as OzMenuRowsRow<EmbedSizeOption>
  }),
)

const onRowSelect = (_event, payload: EmbedSizeOption) => {
  emit('select-row', payload)
}

const emit = defineEmits(['select-row'])
</script>

<template>
  <SurfaceRowDropdown
    :field-label="__('Embed size')"
    :dropdown-label="__('Slideshow embed size dropdown')"
    :button-text="embedSize.title"
    :rows="rows"
    :dark-mode="darkMode"
    :dropdown-test-id="'slideshowEmbedSettingSizeDropdown'"
    :button-test-id="'slideshowEmbedSettingSizeDropdownButton'"
    @select-row="onRowSelect"
  />
</template>
